import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import HostApplicationModal from '../features/host/components/HostApplicationModal';

const AppLayout = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [checkingApplication, setCheckingApplication] = useState(false);

  useEffect(() => {
    // Only check if auth is done loading and user exists
    if (authLoading || !user) {
      setShowApplicationModal(false);
      return;
    }
    
    // Show modal if user is not approved AND hasn't submitted an application
    // Since this is host app, assume all users are hosts
    const checkApplicationStatus = async () => {
      if (user && !user.approvedAsHost) {
        setCheckingApplication(true);
        try {
          // Check if user has already submitted an application
          const appDoc = await getDoc(doc(db, 'hostApplications', user.uid));
          const hasSubmitted = appDoc.exists() && appDoc.data().status === 'pending';
          
          // Only show modal if they haven't submitted an application yet
          if (!hasSubmitted && !user.hostApplicationSubmitted) {
            // Small delay to ensure page is fully rendered
            setTimeout(() => {
              setShowApplicationModal(true);
            }, 800);
          }
        } catch (err) {
          console.error('Error checking application status:', err);
          // On error, don't show modal automatically
        } finally {
          setCheckingApplication(false);
        }
      }
    };

    checkApplicationStatus();
  }, [user, authLoading]); // Removed isHost since we assume all users are hosts

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-emerald-50/40 via-white to-green-50/20">
      <AppHeader />
      <main className="flex-1">
        {children}
      </main>
      <AppFooter />
      {user && (
        <HostApplicationModal
          isOpen={showApplicationModal}
          onClose={() => setShowApplicationModal(false)}
          userId={user.uid}
        />
      )}
    </div>
  );
};

export default AppLayout;

